var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 28.436 17.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11671",
    "data-name": "Group 11671",
    transform: "translate(-319.564 -26.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_461",
    "data-name": "Line 461",
    x2: 26.436,
    transform: "translate(320.564 27.5)",
    fill: "none",
    stroke: "#2c3a56",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_462",
    "data-name": "Line 462",
    x2: 19,
    transform: "translate(328 35.324)",
    fill: "none",
    stroke: "#2c3a56",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_463",
    "data-name": "Line 463",
    x2: 23.436,
    transform: "translate(323.564 43.148)",
    fill: "none",
    stroke: "#2c3a56",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.104d0af5a2b8f3f4216f6a7374627b96.svg";
export { ForwardRef as ReactComponent };